import { useState } from "react";
import { isEqual, findIndex } from "lodash";

export const useHighlight = (roleLabels, attr, qaAttributes) => {
    const [highlightRow, setHighlightRow] = useState(false);
    const [highlightCell, setHighlightCell] = useState(false);

    const PREP_INSTRUCTIONS_PARENT_UUID = "7968502982426757866";
    const FOOD_PRECAUTIONS_UUID = "302874978411916546";
    const PREP_INSTRUCTIONS_LIST_UUID = "5761066931759447496";
    const PREP_METHOD = "8955533540963810264";
    const PREP_TEXT = "8909707730040472637";

    const trimValues = (value) => {
        if (typeof value === "boolean") {
            return value;
        }

        if (!value || !attr) {
            return;
        }

        if (attr.componentType === "StringList") {
            return value.map((val) => val.trim());
        }

        if (attr.componentType === "String") {
            return value.trim();
        }

        return value;
    };

    const checkForTruthyValue = (value) => {
        if (value === null || value === undefined) {
            return false;
        }

        if (value === "") {
            return false;
        }

        if (Array.isArray(value) && value.length === 0) {
            return false;
        }

        return !(typeof value === "object" && Object.keys(value).length === 0);
    };

    const highlightValues = (role) => {
        if (role.type !== "qa") {
            const otherGroup = roleLabels.find((allRoles) => allRoles.groupName === role.groupName && allRoles.type !== role.type);

            // Standard values are equal
            if (isEqual(trimValues(role.attributes[attr.uuid]), trimValues(otherGroup.attributes[attr.uuid]))) {
                return setHighlightRow(false);
            }

            if (!isEqual(trimValues(role.attributes[attr.uuid]), trimValues(otherGroup.attributes[attr.uuid]))) {
                return setHighlightRow(true);
            }
        }
    };

    const highlightQaCell = () => {
        const coderRoles = roleLabels.filter((role) => role.type !== "qa");

        const qaPrepValues = qaAttributes[PREP_INSTRUCTIONS_PARENT_UUID];
        const coderPrepValues = coderRoles.map((role) => role.attributes[PREP_INSTRUCTIONS_PARENT_UUID]);

        const checkMatchingPrepInfo = (val1, val2) => JSON.stringify(val1) === JSON.stringify(val2);

        const isComparePrepListEqual = (val1, val2) => {
            if (val1?.length !== val2?.length) {
                return false;
            }

            const differentValuesList =
                val2 &&
                val2.filter((qa) => {
                    return val1.every((coder) => {
                        return qa[PREP_METHOD].value !== coder[PREP_METHOD].value || qa[PREP_TEXT] !== coder[PREP_TEXT];
                    });
                });

            return differentValuesList.length === 0;
        };

        if (attr.uuid === PREP_INSTRUCTIONS_PARENT_UUID && qaPrepValues && coderPrepValues) {
            const hasMatchingCoderPrep = checkMatchingPrepInfo(coderPrepValues[0], coderPrepValues[1]);

            const hasSamePrecautions = coderPrepValues.find((val) => val && val[FOOD_PRECAUTIONS_UUID] === qaPrepValues[FOOD_PRECAUTIONS_UUID]);

            if (hasMatchingCoderPrep) {
                const hasSamePrepList =
                    hasSamePrecautions &&
                    checkMatchingPrepInfo(hasSamePrecautions[PREP_INSTRUCTIONS_LIST_UUID], qaPrepValues[PREP_INSTRUCTIONS_LIST_UUID]);

                if (hasSamePrepList) {
                    return setHighlightCell(false);
                } else {
                    return setHighlightCell(true);
                }
            }

            if (!hasMatchingCoderPrep) {
                const hasSamePrepList =
                    hasSamePrecautions &&
                    isComparePrepListEqual(hasSamePrecautions[PREP_INSTRUCTIONS_LIST_UUID], qaPrepValues[PREP_INSTRUCTIONS_LIST_UUID]);

                if (hasSamePrepList) {
                    setHighlightCell(false);
                } else {
                    setHighlightCell(true);
                }
            }
        }

        const check = findIndex(coderRoles, {
            attributes: {
                [attr.uuid]: qaAttributes[attr.uuid],
            },
        });

        if (check === -1 && checkForTruthyValue(qaAttributes[attr.uuid])) {
            setHighlightCell(true);
            setHighlightRow(false);
        }

        if (!checkForTruthyValue(qaAttributes[attr.uuid])) {
            setHighlightCell(false);
            roleLabels.forEach((role) => {
                highlightValues(role);
            });
        }
    };

    return { highlightRow, highlightCell, highlightValues, highlightQaCell };
};
